var map = {
	"./aastra.jpg": 183076,
	"./grandstream.jpg": 857892,
	"./jami.jpg": 808661,
	"./linphone.jpg": 849411,
	"./microsip.jpg": 710920,
	"./panasonic.jpg": 976028,
	"./unknown.jpg": 794840,
	"./yealink.jpg": 705437,
	"./zoiper.jpg": 515963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42204;